enum WalletTypes {
  TENANT = "TENANT",
  MANAGER = "MANAGER",
  USER = "USER"
}

export default WalletTypes
